<template>
    <div class="main-body">
        <h2>{{ $strings('spsite/transaction/detail/title') }}</h2>
        <div class="action-bar">
            <div class="add-wrapper">
                <el-button type="primary" size="small" @click="onCreateClick">{{ $strings('word/create') }}</el-button>
            </div>
            <div class="filter-wrapper">
                <el-form :inline="true" :model="filter" class="demo-form-inline" ref="filter">
                    <el-form-item label="">
                        <el-input v-model="filter.smpp_sender" :placeholder="$strings('word/smpp_sender')" size="small"
                                  class="max-width-120" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <el-input v-model="filter.dest" :placeholder="$strings('word/dest_address')"
                                  size="small"
                                  class="max-width-120" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onFilter" size="small">{{
                                $strings('word/search')
                            }}
                        </el-button>
                        <el-button @click="onReset" size="small">{{ $strings('word/reset') }}</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div>
            <el-table v-loading="loadingTable" border :data="tableData" :row-class-name="tableRowClass">
                <el-table-column prop="link_id" :label="$strings('word/link_id')" width="100"></el-table-column>
                <el-table-column prop="message" :label="$strings('word/message')" width="300"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="dlr_is" :label="$strings('word/dlr_is')" width="300"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="dlr_code" :label="$strings('word/dlr_code')" width="100"></el-table-column>
                <el-table-column prop="smpp_host" :label="$strings('word/smpp_host')" width="140"></el-table-column>
                <el-table-column prop="smpp_port" :label="$strings('word/smpp_port')" width="100"></el-table-column>
                <el-table-column prop="smpp_user" :label="$strings('word/smpp_user')" width="100"></el-table-column>
                <el-table-column prop="smpp_pass" :label="$strings('word/smpp_pass')" width="100"></el-table-column>
                <el-table-column prop="smpp_sender" :label="$strings('word/smpp_sender')" width="100"></el-table-column>
                <el-table-column prop="dest" :label="$strings('word/dest_address')" width="120"></el-table-column>
                <el-table-column prop="ct_time" :label="$strings('word/ct_time')" width="160">
                    <template slot-scope="scope">{{ unix2date(scope.row.ct_time) }}</template>
                </el-table-column>
                <el-table-column prop="dlr_time" :label="$strings('word/dlr_time')" width="160">
                    <template slot-scope="scope">{{ unix2date(scope.row.dlr_time) }}</template>
                </el-table-column>
                <el-table-column prop="" :label="$strings('word/operation')" width="160" fixed="right">
                    <template slot-scope="scope">
                        <el-button @click="onDeleteItem(scope.row)" size="small">{{
                                $strings('word/delete')
                            }}
                        </el-button>
                        <el-button @click="onCopyItem(scope.row)" size="small">{{ $strings('word/copy') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination table-pagination" v-if="!loadingTable && pagination.total > pagination.size">
                <el-pagination background layout="prev, pager, next" :total="pagination.total"
                               :page-size.sync="pagination.size"
                               :current-page.sync="pagination.page"
                               @current-change="refreshTable"></el-pagination>
            </div>
        </div>
        <div>
            <el-dialog
                :title="$strings('word/create')"
                :visible.sync="create_dialog.visible"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :show-close="false"
                @closed="onCreateDialogClose"
                width="500px">
                <div>
                    <el-form ref="form" :model="create_dialog.form" label-width="120px" :rules="create_dialog.rules">
                        <el-form-item :label="$strings('word/smpp_sender')">
                            <el-select v-model="create_dialog.form.link_id" @change="onChangeSender">
                                <el-option v-for="(val, key) in options.senders" :key="key" :label="val.label"
                                           :value="val.value"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item :label="$strings('word/smpp_host')">
                            <el-input v-model="create_dialog.form.smpp_host" disabled></el-input>
                        </el-form-item>
                        <el-form-item :label="$strings('word/smpp_port')">
                            <el-input v-model="create_dialog.form.smpp_port" disabled></el-input>
                        </el-form-item>
                        <el-form-item :label="$strings('word/smpp_user')">
                            <el-input v-model="create_dialog.form.smpp_user" disabled></el-input>
                        </el-form-item>
                        <el-form-item :label="$strings('word/smpp_pass')">
                            <el-input v-model="create_dialog.form.smpp_pass" disabled></el-input>
                        </el-form-item>

                        <el-form-item :label="$strings('word/sender')" prop="smpp_sender">
                            <el-input v-model="create_dialog.form.smpp_sender" clearable maxlength="8"
                                      show-word-limit></el-input>
                        </el-form-item>
                        <el-form-item :label="$strings('word/dest_address')" prop="dest">
                            <el-input v-model="create_dialog.form.dest" clearable maxlength="24"
                                      show-word-limit></el-input>
                        </el-form-item>
                        <el-form-item :label="$strings('word/message')" prop="message">
                            <el-input type="textarea" v-model="create_dialog.form.message" clearable maxlength="160"
                                      show-word-limit rows="5"></el-input>
                        </el-form-item>
                        <el-form-item :label="$strings('word/is_unicode')">
                            <el-checkbox v-model="create_dialog.form.is_unicode">{{ $strings('word/is_unicode') }}
                            </el-checkbox>
                        </el-form-item>

                        <el-form-item :label="$strings('word/result')" v-if="create_dialog.waiting">
                            <el-alert
                                :title="create_dialog.result.title"
                                :type="create_dialog.result.type"
                                effect="dark">
                            </el-alert>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="create_dialog.visible = false" :loading="create_dialog.sending">
                        {{ $strings('word/cancel') }}
                    </el-button>
                    <el-button type="primary" @click="onSend()" :loading="create_dialog.sending">
                        {{ $strings('word/send') }}
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {
    SpSiteMessageRead,
    SpSiteSpAppRead,
    SpSiteTransactionTestCreate,
    SpSiteTransactionTestDelete,
    SpSiteTransactionTestRead,
    SpSiteTransactionTestSend
} from "@/api/spsite/api";
import {UnixToDateFull} from "@/utils/time";
import {GetItem} from "@/utils/storage";
import {DLR_STATUS, DLR_SUCCESS, STORAGE_KEY_LOGIN_TZ} from "@/config/config";

export default {
    name: "spsite-transaction-test",
    components: {},
    data() {
        return {
            loadingTable: true,
            tableData: [],
            pagination: {total: 0, page: 1, size: 12},
            filter: {smpp_sender: '', dest: ''},
            loadingContent: false,
            mapping: {cps: {}, senders: {}},
            dlr_status_str: DLR_STATUS,

            // create dialog
            create_dialog: {
                visible: false,
                sending: false,
                waiting: false,
                form: {},
                result: {
                    title: 'waiting...',
                    type: 'success'
                },
                rules: {
                    message: [
                        {required: true, message: this.$strings('word/field_empty'), trigger: 'blur'},
                        {min: 0, max: 160, message: this.$strings('word/field_invalid'), trigger: 'blur'}
                    ],
                    smpp_sender: [
                        {required: true, message: this.$strings('word/field_empty'), trigger: 'blur'},
                        {min: 0, max: 8, message: this.$strings('word/field_invalid'), trigger: 'blur'}
                    ],
                    dest: [
                        {required: true, message: this.$strings('word/field_empty'), trigger: 'blur'},
                        {min: 0, max: 24, message: this.$strings('word/field_invalid'), trigger: 'blur'}
                    ]
                }
            },
            options: {
                senders: [],
            },
        }
    },
    created() {
        this.prepare();
        this.refreshTable();
    },
    computed: {},
    methods: {

        tableRowClass({row}) {
            return row && row.dlr_code * 1 === DLR_SUCCESS ? 'row-success' : '';
        },

        // create dialog
        prepare() {
            SpSiteSpAppRead({page: 1, size: 1000}).then((resp) => {
                this.options.senders = [];
                this.mapping.senders = {};
                resp.data.data.rows.forEach(item => {
                    this.options.senders.push({
                        label: item.sp_id + '/' + item.app_name,
                        value: item.link_id,
                    });
                    this.mapping.senders[item.link_id] = item;
                })
            });
        },
        onChangeSender() {
            let sender = this.mapping.senders[this.create_dialog.form.link_id];
            console.log(this.create_dialog.form.link_id, this.mapping.senders)
            this.create_dialog.form.smpp_host = sender.smpp_host;
            this.create_dialog.form.smpp_port = sender.smpp_port;
            this.create_dialog.form.smpp_user = sender.smpp_user;
            this.create_dialog.form.smpp_pass = sender.smpp_pass;
            this.create_dialog.form.smpp_sender = sender.smpp_sender;
        },
        onCreateClick() {
            this.create_dialog.sending = false;
            this.create_dialog.waiting = false;
            this.create_dialog.form = {};
            this.create_dialog.result.title = 'waiting...'
            this.create_dialog.result.type = 'info'
            this.create_dialog.visible = true;
        },
        onCopyItem(row) {
            this.onCreateClick();
            this.create_dialog.form = row;
        },
        onCreateDialogClose() {
            this.refreshTable();
        },
        onSend() {
            this.create_dialog.sending = true;
            this.create_dialog.waiting = true;
            this.create_dialog.form.is_unicode = 1 * this.create_dialog.form.is_unicode;
            // create first
            SpSiteTransactionTestCreate(this.create_dialog.form).then((resp) => {
                if (resp.data && resp.data.data && resp.data.data.mid && resp.data.data.mid.length > 0) {
                    this.create_dialog.form.mid = resp.data.data.mid;
                    SpSiteTransactionTestSend(this.create_dialog.form).then((resp) => {
                        this.create_dialog.result.title = JSON.stringify(resp.data);
                        if (resp && resp.data && resp.data.data && resp.data.data.ret && resp.data.data.ret.length > 0) {
                            this.create_dialog.result.type = 'success';
                        }
                    }).finally(() => {
                        this.create_dialog.sending = false;
                    })
                } else {
                    this.create_dialog.result.title = "invalid.response";
                    console.log('____resp.err.is', resp);
                }
            })

        },
        onDeleteItem(row) {
            SpSiteTransactionTestDelete(row).then(() => {
                this.refreshTable();
            });
        },

        showMessage(mid) {
            this.loadingContent = true;
            SpSiteMessageRead({mid: mid, page: 1, size: 10}).then((resp) => {
                let content = "";
                if (resp.data.data.count > 0) {
                    content = resp.data.data.rows[0].content
                } else {
                    content = "Missing content"
                }
                this.$alert(content, this.$strings('word/message_content'), {
                    confirmButtonText: 'OK'
                })
            }).catch(() => {

                this.$alert("EMPTY", this.$strings('word/message_content'), {
                    confirmButtonText: 'OK',
                    type: 'error'
                })


            }).finally(() => {
                this.loadingContent = false;
            })
        },
        onLoadCp(cps) {
            this.mapping.cps = {};
            cps.forEach((item) => {
                this.mapping.cps[item.cp_id] = item.cp_name;
            });
        },
        unix2date(ts) {
            return UnixToDateFull(ts, GetItem(STORAGE_KEY_LOGIN_TZ) * 1);
        },
        onFilter() {
            this.refreshTable();
        },
        onReset() {
            this.filter = {};
            this.pagination.page = 1;
            this.refreshTable();
        },
        refreshTable() {
            this.loadingTable = true;
            this.filter.page = this.pagination.page;
            this.filter.size = this.pagination.size;
            SpSiteTransactionTestRead(this.filter).then((resp) => {
                this.pagination.total = resp.data.data.count;
                this.tableData = resp.data.data.count > 0 ? resp.data.data.rows : [];
            }).finally(() => {
                this.loadingTable = false;
            });
        }
    }
}
</script>

<style scoped lang="scss">
.action-bar {
    display: flex;
    flex-direction: row;

    .filter-wrapper {
        display: flex;
        justify-content: flex-end;
        flex-grow: 1;
    }

    .add-wrapper {
        padding-top: 4px;
    }
}

.table-pagination {
    margin-top: 1em;
    display: flex;
    justify-content: flex-end;
}
</style>

<style lang="scss">
tr.row-success {
    font-weight: bold;
    font-style: italic;
}
</style>